import type { CSSProperties } from 'react'
import { cn } from '../lib/cn'
import transport from '../assets/service-transport.png'
import delivery from '../assets/service-delivery.png'
import rental from '../assets/service-rental.png'
import driver from '../assets/service-driver.png'

/**
 * The four activity glyphs, exactly as drawn in the design.
 *
 * These are the design's own artwork, not Lucide look-alikes: the car is a
 * front three-quarter view and there is no steering wheel in Lucide at all, so
 * substituting would change the screen. They are extracted as alpha masks
 * rather than coloured images and painted with `mask-image`, so a single asset
 * serves the slate and brand states and inherits `currentColor` like any icon.
 */
const MASKS = {
  TRANSPORT_PERSON: transport,
  DELIVERY: delivery,
  EQUIPMENT_RENTAL: rental,
  DRIVER_HIRE: driver,
} as const

export type ServiceActivity = keyof typeof MASKS

/** French labels, as the design writes them. */
export const SERVICE_LABEL: Record<ServiceActivity, string> = {
  TRANSPORT_PERSON: 'Transport',
  DELIVERY: 'Livraison',
  EQUIPMENT_RENTAL: 'Location',
  DRIVER_HIRE: 'Conducteur',
}

export function ServiceIcon({
  activity,
  className,
}: {
  activity: ServiceActivity
  className?: string
}) {
  const mask: CSSProperties = {
    maskImage: `url(${MASKS[activity]})`,
    WebkitMaskImage: `url(${MASKS[activity]})`,
    maskSize: 'contain',
    WebkitMaskSize: 'contain',
    maskRepeat: 'no-repeat',
    WebkitMaskRepeat: 'no-repeat',
    maskPosition: 'center',
    WebkitMaskPosition: 'center',
    backgroundColor: 'currentColor',
  }
  return <span aria-hidden="true" className={cn('block size-8', className)} style={mask} />
}
